import {Component, Input, OnInit} from '@angular/core';
import {OnResult} from '../../../class/interface/on-result';
import {PdfViewerComponentComponent} from '../../pdf-viewer-component/pdf-viewer-component.component';
import {NbWindowService} from '@nebular/theme';
import {FileReference} from '../../../class/file-reference';

@Component({
  selector: 'app-base-result',
  templateUrl: './base-result.component.html',
  styleUrls: ['./base-result.component.css']
})
export class BaseResultComponent implements OnInit, OnResult {

  private BASE_INFO_PDF_URL = "https://prospettivawefare-public.s3-eu-west-1.amazonaws.com/resources/cover/"

  @Input()
  hide: boolean;

  @Input()
  showTitle = true;

  @Input()
  pdfInfoName;

  private pdfResource: FileReference;

  constructor(protected windowService: NbWindowService) {
  }

  public OnResult() {
    this.onResultImpl();
  }

  ngOnInit() {
    this.ngOnInitImpl();
    this.pdfResource = new FileReference();
    this.pdfResource.bucketName = 'prospettivawelfare';
    this.pdfResource.path = 'WelfyData/cover/' + this.pdfInfoName;
    this.pdfResource.fileName = this.pdfInfoName;
  }

  onResultImpl(): void {
  }

  ngOnInitImpl(): void {
  }

  showPdf() {
    const url =  this.BASE_INFO_PDF_URL + this.pdfInfoName;
    this.windowService.open(PdfViewerComponentComponent, {title: 'Info', context: {pdfSrc: url}});
  }

}
